export BoatIcon from '@material-ui/icons/DirectionsBoat'
export BoatList from './List'
export BoatCreate from './Create'
export BoatEdit from './Edit'
export BoatShow from './Show'
export BoatQueries from './queries'
